module.exports = {
  zh: {
    systemSet: {
      logo: '平台LOGO',
      name: '系统名称',
      time: '日报定时发送',
      isCheck: '日报是否审核',
    },
    edit: '编辑',
    confirm: '确 定',
    cancel: '取 消',
    action: "操作",
    add: "新增",
    addActive:"添加活动",
    pwdChange: {
      thatPwd: '原密码',
      newPwd: '新密码',
      newPwd2: '确认密码',
      message: "密码长度是6-18位的数字、字符。",
    },

    // 字典
    Journal: {
      title: "术语域",
      name: '术语名称',
      activeName:'活动名称',
    },
    information: {
      title: '基本信息',
      number: '编号',
      ChineseName: '中文名称',
      EnglishName: '英文名称',
      sex: '性别',
      phone: '手机号码',
      park: '所属园区',
      type: '雇佣类型',
      post: '职务',
      role: '角色',
    }
  },
  en: {
    systemSet: {
      logo: 'LOGO',
      name: 'system',
      time: 'Log sending time ',
      isCheck:"Check"
    },
    edit: 'edit',
    cancel: 'cancel',
    confirm: 'Determine',
    add: "Add",
    addActive:"addActive",
    action: "Action",
    pwdChange: {
      thatPwd: 'Original cipher',
      newPwd: 'New password',
      newPwd2: 'Confirm the password',
      message: "The password length is the number and character of the 6-18 bit.",
    },
    // 字典
    Journal: {
      title: "Term Type",
      name: 'Term',
      activeName:'Activity Name ',
    },
    information: {
      title: 'information',
      number: 'number',
      ChineseName: 'Chinese name',
      EnglishName: 'English name',
      sex: 'sex',
      phone: 'phone',
      park: 'Affiliated Park',
      type: 'type of emoloyment',
      post: 'post',
      role: 'role',
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/i18n/lang/stsytemset.js